import * as React from 'react'

import {IconAvatar} from '@/assets/specify/IconAvatar'
import {IconBank} from '@/assets/specify/IconBank'
import {IconBasket} from '@/assets/specify/IconBasket'
import {IconBuilding} from '@/assets/specify/IconBuilding'
import {IconHeart} from '@/assets/specify/IconHeart'
import {IconInternet} from '@/assets/specify/IconInternet'
import {IconLinkedin} from '@/assets/specify/IconLinkedin'
import {IconMessage} from '@/assets/specify/IconMessage'
import {IconNotes} from '@/assets/specify/IconNotes'
import {IconPlay} from '@/assets/specify/IconPlay'
import {IconSettings} from '@/assets/specify/IconSettings'
import {IconTwitter} from '@/assets/specify/IconTwitter'
import {IconUmbrella} from '@/assets/specify/IconUmbrella'

const DynamicIcon = (props) => {
  switch (props.icon) {
    case 'IconBank':
      return <IconBank />
    case 'IconAvatar':
      return <IconAvatar />
    case 'IconBasket':
      return <IconBasket />
    case 'IconBuilding':
      return <IconBuilding />
    case 'IconHeart':
      return <IconHeart />
    case 'IconInternet':
      return <IconInternet />
    case 'IconLinkedin':
      return <IconLinkedin />
    case 'IconMessage':
      return <IconMessage />
    case 'IconNotes':
      return <IconNotes />
    case 'IconPlay':
      return <IconPlay />
    case 'IconSettings':
      return <IconSettings />
    case 'IconTwitter':
      return <IconTwitter />
    case 'IconUmbrella':
      return <IconUmbrella />
    default:
      return null
  }
}

export default DynamicIcon
